<mat-menu #addAsset="matMenu" yPosition="below" xPosition="before" class="dropdown-menu-panel">
  @if (mode != 'view' && allowEditPermission) {
    <div id="add-asset-form-association-search-box" appClickOutside class="search-container">
      <form>
        <mat-form-field appearance="fill" style="margin: 12px; width: -webkit-fill-available" class="form_input file-search" id="myfield">
          <mat-icon style="color: #707070" matSuffix>search </mat-icon>
          <input
            #assetInput
            type="text"
            matInput
            aria-label="Number"
            [matAutocomplete]="'auto'"
            [formControl]="associationForm"
            placeholder="Search asset"
            id="search_input"
            />
            {{ assetInput.focus() }}
          </mat-form-field>
          @if (locationDatalist?.length == 0 || noMatchFound) {
            <p style="color: rgb(198, 193, 193); font-size: 15px; padding: 0 12px">
              No results found
            </p>
          }
          @if (locationDatalist?.length) {
            <div class="search-result-continer">
              @for (data of locationDatalist; track data) {
                <div class="search-result-item" (click)="selectAssociatedUser($event, data)">
                  <div style="display: flex" class="mrr-10px" matTooltip="{{ data?.form_name ? data?.form_name : data?.name }}">
                    @if (data.form_name && data.profile_image_url) {
                      <div class="form-image-container">
                        <img [src]="data.profile_image_url" alt="" />
                      </div>
                    }
                    @if (data.name && !data.profile_image_url) {
                      <div class="form-image-container">
                        <mat-icon style="font-size: 19px; padding: 4px 2px; color: #25508e; position: relative; left: 6px">check_circle</mat-icon>
                      </div>
                    }
                    <p style="margin: 12px 0px; width: 160px" class="dropdown-text1 text-truncate">
                      <strong>
                        {{ data.form_name | titlecase }}
                        {{ data.name | titlecase }}
                      </strong>
                    </p>
                  </div>
                  <p style="margin: 12px 0px; min-width: 90px" class="update-at-title text-truncate">
                    {{ data.type_template | titlecase }}
                  </p>
                </div>
              }
            </div>
          }
        </form>
      </div>
    }
  </mat-menu>
  <div class="container" id="add-asset-form-association-container">
    @if (isDataLoading) {
      <div class="ph-item w-full loader-body-item m-0 p-0 border-0">
        <div class="ph-col-12 p-0 pt-6">
          <div class="ph-row">
            <div class="ph-col-4 h-[10px]"></div>
            <div class="ph-col-6 empty"></div>
            <div class="ph-col-2 h-[10px]"></div>
          </div>
        </div>
      </div>
    }
    @if (!isDataLoading) {
      <mat-dialog-content class="mat-dialog-content">
        <mat-accordion class="prevent-click" [@.disabled]="true">
          <mat-expansion-panel
            [expanded]="formatAddedData?.length == 0 ? false : true"
            class="parametersPanel"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
        style="
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
          box-shadow: none;
        "
            [ngClass]="formatAddedData?.length == 0 ? 'setEmptyPanelDefault' : ''"
            >
            <mat-expansion-panel-header class="disable_ripple" style="height: 32px !important">
              <mat-panel-title>
                <div class="header-section">
                  <p (click)="$event.stopPropagation()">
                    Assets
                    @if (formatAddedData?.length) {
                      <span> ({{ formatAddedData?.length }}) </span>
                    }
                  </p>
                  @if (mode != 'view' && allowEditPermission) {
                    <button
                      class="add-item-button"
                      (click)="$event.stopPropagation()"
                      mat-button
                      [matMenuTriggerFor]="addAsset"
                      #menuOwnership="matMenuTrigger"
                      [disableRipple]="true"
                      (menuOpened)="(menuOwnership.menuOpen)"
                      (menuClosed)="(menuOwnership.menuOpen)"
                      >
                      <span style="color: #25508e; font-size: 16px" class="material-icons">add</span>
                      <span style="position: relative; left: 8px"> Add </span>
                    </button>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              @if (formatAddedData.length == 0) {
                <p class="noFileSection">No assets added</p>
              }
              <div class="folder-view__association-files" style="margin: 9px -24px 0 -24px !important">
                <div class="association-files-table flex fl-col width-100per">
                  <div class="width-100per">
                    @for (subLink of formatAddedData; track subLink; let i = $index) {
                      <div
                        class="association-files-table__body width-100per"
                        style="background: #ffffff"
                        >
                        <div style="display: flex; justify-content: space-between">
                          <div
                            class="body-card flex"
                            style="padding: 0px 21px 6px 15px !important; width: 100%; border-radius: 5px; justify-content: space-between"
                            >
                            <div class="test-zeropostion">
                              <div style="display: flex" class="mrr-10px" matTooltip="{{ subLink?.form_name ? subLink?.form_name : subLink?.name }}">
                                @if (subLink.vault_form_id && subLink.profile_image_url) {
                                  <div class="form-image-container">
                                    <img [src]="subLink.profile_image_url" alt="" />
                                  </div>
                                }
                                @if (!subLink.vault_form_id && !subLink.profile_image_url) {
                                  <div class="form-image-container">
                                    <mat-icon style="font-size: 19px; padding: 4px 2px; color: #25508e">check_circle</mat-icon>
                                  </div>
                                }
                                <p
                                  class="name-title text-truncate"
                                  (click)="!(mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing) ? viewModal(subLink, $event) : null"
                                  style="position: relative; top: 8px; font-weight: normal !important"
                                  >
                                  {{ subLink?.form_name?.slice(0, 30) | titlecase }}
                                  {{ subLink?.name?.slice(0, 30) | titlecase }}
                                  {{ subLink?.form_name?.length > 30 || subLink?.name?.length > 30 ? '...' : '' }}
                                </p>
                              </div>
                            </div>
                            <div class="last-item">
                              <button
                                class="more-vote-btn"
                                style="position: relative; left: 18px; top: 4px"
                                mat-icon-button
                                [matMenuTriggerFor]="menuItem"
                                [disableRipple]="true"
                                >
                                <span class="material-icons">more_vert</span>
                              </button>
                              <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                                @if (!(mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing)) {
                                  <button
                                    mat-menu-item
                                    class="popup-menu-item remove-link"
                                    (click)="viewModal(subLink, $event)"
                                    >
                                    <span style="color: #25508e; font-size: 16px" class="material-icons">visibility</span>
                                    <span style="position: relative; top: -3px; left: 8px"> Open </span>
                                  </button>
                                }
                                @if (!isRemoveEditSaveSharing && mode != 'view') {
                                  <button
                                    mat-menu-item
                                    class="popup-menu-item remove-link-delete"
                                    (click)="deleteUserFormAssociation(subLink.id, subLink.form_name, subLink)"
                                    >
                                    <span style="font-size: 16px" class="material-icons">delete</span>
                                    <span style="position: relative; top: -3px; left: 8px"> Remove Link </span>
                                  </button>
                                }
                              </mat-menu>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-dialog-content>
    }
  </div>
